/**
 * Quy ước đặt tên chứng từ của SAP Business One: bảng ĐẦU và bảng DÒNG.
 *
 * ── VÌ SAO CẦN BIẾT ────────────────────────────────────────────────────────
 * SAP tách mỗi chứng từ thành hai bảng: phần đầu (`OINV` — một hoá đơn, ngày,
 * khách, tổng tiền) và phần dòng (`INV1` — mỗi dòng một mặt hàng, số lượng,
 * đơn giá). Tên gắn với nhau theo luật: `O` + ba chữ cho bảng đầu, đúng ba chữ
 * ấy + một chữ số cho bảng dòng.
 *
 *     OINV ↔ INV1        ORDR ↔ RDR1        ODLN ↔ DLN1
 *     OPCH ↔ PCH1        OPDN ↔ PDN1        OPOR ↔ POR1
 *
 * Khai bảng đầu mà quên bảng dòng cho ra một bản khai KHÔNG TRẢ LỜI ĐƯỢC câu
 * nào ở mức mặt hàng: "bán mặt hàng nào nhiều nhất", "doanh thu theo nhóm
 * hàng" đều nằm ở bảng dòng. Và triệu chứng chỉ hiện ra sau khi đã đồng bộ
 * xong — trợ lí từ chối, không ai biết vì thiếu một bảng.
 *
 * Một chứng từ có thể có NHIỀU bảng dòng (`RDR1` là dòng hàng, `RDR2`/`RDR3`
 * là phí vận chuyển và kỳ thanh toán), nên hàm trả về danh sách.
 *
 * ── LUẬT NÀY CHỈ ĐOÁN, KHÔNG KHẲNG ĐỊNH ────────────────────────────────────
 * Nó dựa trên hình dạng tên, nên một bảng tên `ocrd` (Đối tác kinh doanh) vẫn
 * khớp khuôn `O` + ba chữ dù nó không có bảng dòng nào. Vì thế mọi hàm ở đây
 * chỉ trả về những bảng CÓ THẬT trong nguồn — không có `crd1` thì không gợi ý
 * gì, và người dùng không thấy một lời nhắc vô nghĩa.
 */

/** `oinv` → `inv`. `null` nếu tên không có hình dạng bảng đầu. */
function tienToDong(tenDau: string): string | null {
  const m = /^o([a-z]{3})$/.exec(tenDau);
  return m?.[1] ?? null;
}

/** Bảng dòng CÓ THẬT trong nguồn, của một bảng đầu. Rỗng nếu không có. */
export function bangDongCua(tenDau: string, coTrongNguon: Set<string>): string[] {
  const tt = tienToDong(tenDau);
  if (!tt) return [];
  const ra: string[] = [];
  for (const x of coTrongNguon) if (new RegExp(`^${tt}\\d+$`).test(x)) ra.push(x);
  return ra.sort();
}

/**
 * Những bảng đầu đang được chọn mà bảng dòng của chúng thì KHÔNG.
 *
 * Trả về cả cặp để lời nhắc nói được tên cụ thể: "OINV thiếu INV1" giúp người
 * đọc hiểu ngay, còn "2 bảng thiếu bảng dòng" thì bắt họ đi tìm.
 */
export function thieuBangDong(
  daChon: Set<string>,
  coTrongNguon: Set<string>,
): { dau: string; dong: string[] }[] {
  const ra: { dau: string; dong: string[] }[] = [];
  for (const dau of daChon) {
    const dong = bangDongCua(dau, coTrongNguon).filter((x) => !daChon.has(x));
    if (dong.length) ra.push({ dau, dong });
  }
  return ra.sort((a, b) => a.dau.localeCompare(b.dau));
}
